var base = require('settings/payment-method/update-payment-method-stripe');

Vue.component('spark-update-payment-method-stripe', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/payment-method/update-payment-method-stripe.js